import { HorizontalSpacerSeparator } from 'common-front/src/designSystem/components/separator';
import { Skeleton } from 'common/src/designSystem/components/skeleton';
import { PositionPermission } from 'common/src/graphql/permissions/dsl';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { Field } from 'react-final-form';
import Group, { Label, Toggle } from './group';
import RoleFormBox from './roleFormBox';

export const PositionsBox = ({ disabled }: { disabled?: boolean }) => {
    const translate = useTranslate();

    return (
        <RoleFormBox
            subtitle={translate('permissions_rel_18662')}
            title={translate('missions_63972')}
        >
            <Field name="role.positionPermissions">
                {({ input }) => (
                    <>
                        <Group>
                            <Label>{translate('informations_su_61022')}</Label>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.EDIT_POSITION}
                                subtext={translate('si_le_r_le_est_05344')}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('_diter_la_missi_86663')}
                            </Toggle>
                        </Group>
                        <HorizontalSpacerSeparator height="6" />
                        <Group>
                            <Label>{translate('affectation')}</Label>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.ASSIGN_MEMBER}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('affecter_des_me_26669')}
                            </Toggle>
                            <Toggle
                                disabled={disabled}
                                permission={PositionPermission.EDIT_ASSIGNMENT_STATE}
                                subtext={translate(
                                    'permet_notammen_90746',
                                    translate('PreAssigned')
                                )}
                                value={input.value}
                                onChange={input.onChange}
                            >
                                {translate('changer_le_stat_34124')}
                            </Toggle>
                        </Group>
                    </>
                )}
            </Field>
        </RoleFormBox>
    );
};

export const PositionsSkeletonBox = () => {
    const translate = useTranslate();

    return (
        <RoleFormBox
            subtitle={translate('permissions_rel_18662')}
            title={translate('missions_63972')}
        >
            <Group>
                <Label>{translate('informations_su_61022')}</Label>
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={60} />
            </Group>
            <HorizontalSpacerSeparator height="6" />
            <Group>
                <Label>{translate('affectation')}</Label>
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={20} />
                <Skeleton borderRadius="$1" css={{ gridColumn: 2 }} height={40} />
            </Group>
        </RoleFormBox>
    );
};
